"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreditBankInfo = void 0;
var react_1 = __importDefault(require("react"));
var CreditBankInfo_module_scss_1 = __importDefault(require("./CreditBankInfo.module.scss"));
var getBankImage_1 = require("../../helpers/bank/getBankImage");
var countProgramm_1 = require("../../helpers/bank/countProgramm");
var getInterestRate_1 = require("../../helpers/bank/getInterestRate");
var Svg_1 = require("../svg/Svg");
var CreditBankInfo = function (props) {
    var bank = props.bank, isOpen = props.isOpen, handler = props.handler, payment = props.payment;
    return (react_1.default.createElement("section", { className: CreditBankInfo_module_scss_1.default.bank_info, onClick: handler },
        react_1.default.createElement("div", { className: CreditBankInfo_module_scss_1.default.bank_info__bank },
            react_1.default.createElement("div", null, (0, getBankImage_1.getBankImage)(bank.name) ? (react_1.default.createElement("img", { loading: "lazy", className: CreditBankInfo_module_scss_1.default.bank_info__img, src: (0, getBankImage_1.getBankImage)(bank.name), alt: bank.name })) : (react_1.default.createElement("div", null, bank.name))),
            react_1.default.createElement("section", { className: CreditBankInfo_module_scss_1.default.bank_info__name },
                react_1.default.createElement("h4", null, bank.name),
                react_1.default.createElement("h5", null, (0, countProgramm_1.getCountProgram)(bank.programs.length)))),
        react_1.default.createElement("div", { className: CreditBankInfo_module_scss_1.default.bank_info__rate },
            react_1.default.createElement("h4", null, "\u0421\u0442\u0430\u0432\u043A\u0430"),
            react_1.default.createElement("h5", null, (0, getInterestRate_1.getInterestRate)(bank.programs))),
        react_1.default.createElement("div", { className: CreditBankInfo_module_scss_1.default.bank_info__payment },
            react_1.default.createElement("h4", null, "\u0415\u0436\u0435\u043C\u0435\u0441\u044F\u0447\u043D\u044B\u0439 \u043F\u043B\u0430\u0442\u0451\u0436"),
            react_1.default.createElement("h5", null,
                payment,
                " \u20BD")),
        react_1.default.createElement(Svg_1.Vector, { isOpen: isOpen })));
};
exports.CreditBankInfo = CreditBankInfo;
